// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"7dc92eb5","241":"5c4c405c","406":"e3afb38b","446":"9781a31e","460":"84362f36","488":"22b449f6","597":"cd5ade36","660":"729af5b4","728":"62fffdbe","730":"a27548ff","969":"47a6a1ce","979":"51a28a35"}[chunkId] + ".chunk.js";
};